module.exports = __webpack_public_path__ + "static/media/dapp.8ddab395.png";